import { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { ApiContextType } from '../contexts/ApiContext';
import { AuthenticationContextType } from '../contexts/AuthenticationContext';
import { HealthCenterContextType } from '../contexts/HealthCenterContext';
import { UserAppContextType } from '../contexts/UserAppContext';
import { RequireNotificationPermission } from '../notifications/RequireNotificationPermission';

type RouterContext = {
  healthCenterContext: HealthCenterContextType;
  queryClient: QueryClient;
  authenticationContext: AuthenticationContextType;
  userAppContext: UserAppContextType;
  apiContext: ApiContextType;
};

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () =>
    import.meta.env.DEV ? (
      <RootComponent />
    ) : (
      <RequireNotificationPermission>
        <RootComponent />
      </RequireNotificationPermission>
    ),
});

function RootComponent() {
  return (
    <>
      <Outlet />
    </>
  );
}
